import { XMLNode } from "../../fileToolbar/fileToolbarTypes";
import { getDataReader, RPWDataReader } from "../../livedataFuncs";
import { store } from "../../redux/store";
import { GuarantorType, PriorOwnerType, PurchaserType, VendorType } from "../../SideDrawer/sideTypes";

export function getDefectNodesAsArray(defectNodes: Array<ajaxslt.XNode>): Array<XMLNode> {
    let retArr = [];
    for (let i = 0; i < defectNodes.length; i++) {
        let type = (defectNodes[i].getAttribute('type'));
        if (type === undefined || type === null)
            continue;
        if ((defectNodes[i].getAttribute('type')).startsWith('21_')) {
            retArr.push(defectNodes[i]);
        } else if ((defectNodes[i].getAttribute('type')) == '' || defectNodes[i].getAttribute('type') == null || defectNodes[i].getAttribute('type') == undefined) {
            defectNodes[i].setAttribute('type', '21_5');
            retArr.push(defectNodes[i]);
        }
    }
    return retArr;
}

export function getTransfereeNodes(): Array<PurchaserType> {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let nameArray = [];
    let transfereeNodes = DataReaderObj.getBuyerPeopleInfo();
    transfereeNodes.map((ele) => {
        nameArray.push(
            ele
        )
    })
    return nameArray;
}

export function getTransferorNodes(): Array<VendorType> {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let nameArray = [];
    let transfereeNodes = DataReaderObj.getSellerPeopleInfo();
    transfereeNodes.map((ele) => {
        nameArray.push(
            ele
        )
    })
    return nameArray;
}

export function getGuarantorInfo(): Array<GuarantorType> {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let nameArray = [];
    let guarantorNodes = DataReaderObj.getGuarantorInfo();
    for (let i = 0; i < guarantorNodes.length; i++) {
        nameArray.push({
            Name: guarantorNodes[i].getAttribute('Name'),
        })
    }
    return nameArray;
}

export function cleanDefectNodes(dataRoot): void {
    let defectNodes = dataRoot.selectNodes('Defect');
    for (let i = 0; i < defectNodes.length; i++) {
        let data = defectNodes[i].selectSingleNode('Data');
        let type = defectNodes[i].getAttribute("type");
        if (type === '21' || type.indexOf('21_') === 0) {
            let AgainstReal = data?.getAttribute('AgainstReal');
            if (AgainstReal === null || AgainstReal === undefined || AgainstReal === '') {
                if (i !== (defectNodes.length - 1)) {
                    dataRoot.removeChild(defectNodes[i]);
                }
            }
        }
    }
}

export function getPriorOwnersInfo(): Array<PriorOwnerType> {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let priorOwnerNodes = DataReaderObj.getPriorOwnerInfo();
    return priorOwnerNodes;
}